var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 78,
    height: 78,
    rx: 15,
    fill: "#4A86F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.25 57.75H21.75C20.9203 57.75 20.25 57.0797 20.25 56.25V21.75C20.25 20.9203 20.9203 20.25 21.75 20.25H56.25C57.0797 20.25 57.75 20.9203 57.75 21.75V56.25C57.75 57.0797 57.0797 57.75 56.25 57.75ZM32.25 28.125C32.25 27.9188 32.0813 27.75 31.875 27.75H28.125C27.9187 27.75 27.75 27.9188 27.75 28.125V49.875C27.75 50.0813 27.9187 50.25 28.125 50.25H31.875C32.0813 50.25 32.25 50.0813 32.25 49.875V28.125ZM41.25 41.25C41.25 41.0438 41.0812 40.875 40.875 40.875H37.125C36.9188 40.875 36.75 41.0438 36.75 41.25V49.875C36.75 50.0813 36.9188 50.25 37.125 50.25H40.875C41.0812 50.25 41.25 50.0813 41.25 49.875V41.25ZM50.25 37.875C50.25 37.6688 50.0812 37.5 49.875 37.5H46.125C45.9188 37.5 45.75 37.6688 45.75 37.875V49.875C45.75 50.0813 45.9188 50.25 46.125 50.25H49.875C50.0812 50.25 50.25 50.0813 50.25 49.875V37.875Z",
    fill: "#4A86F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainProject);
export default __webpack_public_path__ + "static/media/mainProject.23f6ea5edc9e0c6517ec0c0bb5a44054.svg";
export { ForwardRef as ReactComponent };